import { PersonAddOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

const LoanDrilldownIconButtonAddContact = ({
  title = "Add Loan Contact",
  onClick,
  sx,
}) => {
  return (
    <Tooltip title={title}>
      <IconButton sx={sx} onClick={onClick}>
        <PersonAddOutlined className="thin" />
      </IconButton>
    </Tooltip>
  );
};

export default LoanDrilldownIconButtonAddContact;
